import React from 'react';
import { PlatformGlyph, IconExternal, IconCheck } from '../lib/icons';

function openSite(url) {
  if (url) window.open(url, '_blank', 'noopener');
}

const defaultKey = (platform, accountId) => (accountId ? `${platform}:${accountId}` : platform);

function nameOf(row) {
  const acct = row.acct;
  return acct ? acct.label || acct.username || row.accountId : row.platform;
}

export default function ManualBar({ rows, colorOf, onConfirm, busy, busyKey }) {
  const pending = rows.filter((r) => r.entry && r.entry.manual && r.entry.pending && !r.entry.ok);
  const total = rows.length;
  if (total === 0 || pending.length === 0) return null;

  const done = total - pending.length;
  const pct = Math.round((done / total) * 100);
  const next = pending[0];
  const nextUrl = next.entry && next.entry.url;
  const nextProfile = next.acct && next.acct.profile;

  return (
    <div className="manual-bar">
      <div className="manual-head">
        <span className="manual-title">
          Checklist de publicação manual
        </span>
        <span className="badge info">
          {done}/{total} confirmadas
        </span>
      </div>

      <div className="bar-track manual-track">
        <div className="bar-fill" style={{ width: `${pct}%` }} />
      </div>

      <div className="manual-next">
        <div className="manual-next-info">
          <span className="row-logo" style={{ background: colorOf ? colorOf(next.platform) : '#6d5cff' }}>
            <PlatformGlyph id={next.platform} size={14} />
          </span>
          <div style={{ minWidth: 0 }}>
            <div className="title" style={{ fontSize: 13 }}>
              Próxima: {nameOf(next)}
            </div>
            <div className="meta">
              {nextProfile ? `Perfil “${nextProfile}” no navegador` : 'Conta já logada no navegador'}
            </div>
          </div>
        </div>
        <div className="actions">
          <button type="button" className="btn primary small" onClick={() => openSite(nextUrl)}>
            <span className="btn-ico">
              <IconExternal size={14} />
            </span>
            Abrir próxima conta
          </button>
          {onConfirm ? (
            <button
              type="button"
              className="btn success small"
              disabled={Boolean(busy) && busy === (busyKey ? busyKey(next.platform, next.accountId) : defaultKey(next.platform, next.accountId))}
              onClick={() => onConfirm(next.platform, next.accountId)}
            >
              <span className="btn-ico">
                <IconCheck size={14} />
              </span>
              Confirmar
            </button>
          ) : null}
        </div>
      </div>

      <div className="chips manual-chips">
        {pending.map((row) => (
          <button
            type="button"
            key={row.key}
            className="chip"
            title={row.acct && row.acct.profile ? `Abrir em “${row.acct.profile}”` : 'Abrir site da plataforma'}
            onClick={() => openSite(row.entry.url)}
          >
            <span className="chip-logo" style={{ background: colorOf ? colorOf(row.platform) : '#6d5cff' }}>
              <PlatformGlyph id={row.platform} size={12} />
            </span>
            {nameOf(row)}
            {row.acct && row.acct.profile ? ` · ${row.acct.profile}` : ''}
          </button>
        ))}
      </div>
    </div>
  );
}
